import { get } from 'lodash/fp';

const useSortArray = () => {
  const sortedArray = (array, key) => array.sort((a, b) => get(key, a) - get(key, b));
  return sortedArray;
};

export default useSortArray;
